export interface HeroSlide {
  videoId: string;
  image: string;
  title: string;
  subtitle: string;
  tags: string[];
}

export const heroSlides: HeroSlide[] = [
  {
    videoId: "v001",
    image: "https://readdy.ai/api/search-image?query=ancient%20chinese%20river%20town%20at%20dusk%20with%20a%20lone%20ferry%20boat%20and%20warm%20lanterns%2C%20cinematic%20hero%20backdrop%2C%20deep%20navy%20and%20teal%20palette%2C%20dramatic%20moody%20lighting%2C%20stylized%20painterly%20illustration%2C%20wide%20panoramic%20composition&width=1600&height=900&seq=jingpin-hero-1&orientation=landscape",
    title: "长风渡口",
    subtitle: "乱世渡口，一场误会，一生携手。年度古装情感大剧，全网热播中。",
    tags: ["古装", "爱情", "热播"],
  },
  {
    videoId: "v017",
    image: "https://readdy.ai/api/search-image?query=spaceship%20flying%20through%20a%20vast%20glowing%20colorful%20nebula%2C%20cinematic%20hero%20backdrop%2C%20deep%20navy%20and%20teal%20palette%2C%20dramatic%20moody%20lighting%2C%20stylized%20painterly%20illustration%2C%20wide%20panoramic%20composition&width=1600&height=900&seq=jingpin-hero-2&orientation=landscape",
    title: "星海旅人",
    subtitle: "少年驶向浩瀚星海，只为寻找失散的家人。年度最高分科幻动画。",
    tags: ["科幻", "冒险", "高分"],
  },
  {
    videoId: "v006",
    image: "https://readdy.ai/api/search-image?query=armored%20figure%20standing%20in%20a%20vast%20snowy%20arctic%20night%20with%20aurora%2C%20cinematic%20hero%20backdrop%2C%20deep%20navy%20and%20teal%20palette%2C%20dramatic%20moody%20lighting%2C%20stylized%20painterly%20illustration%2C%20wide%20panoramic%20composition&width=1600&height=900&seq=jingpin-hero-3&orientation=landscape",
    title: "极夜行动",
    subtitle: "极夜之下，一场关乎人类未来的秘密行动正式启动。",
    tags: ["动作", "科幻", "新片"],
  },
];